import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const fetchEndpointGroups = async (activeTab: string, tenantName: string) => {
    const url = `${NGROK}/api/endpoints-category?tenantName=${tenantName}&os=${activeTab.toUpperCase()}`;
    const data = await apiClient({
        method: "GET",
        url,
    });
    return data.sort((a: any, b: any) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;

        return dateB - dateA;
    });
}

export const fetchComputerForCategory = async (activeTab: string, tenantName: string): Promise<any[]> => {
    const url = `${NGROK}/api/endpoints-category/computers?tenantName=${tenantName}&os=${activeTab.toUpperCase()}`;
    const data = await apiClient<any[]>({
        method: "GET",
        url,
    });
    return data;
}
export const addGroupDetails = async (payload: any) => {
    let url = `${NGROK}/api/endpoints-category`;
    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });
    return data;
}

export const editGroupDetails = async (payload: any) => {
    let url = `${NGROK}/api/endpoints-category`;
    const data = await apiClient({
        method: "PUT",
        url,
        data: payload
    });
    return data;
}

export const deleteDeviceGroup = async (uuid: string) => {

    let url = `${NGROK}/api/endpoints-category/${uuid}`;

    const data = await apiClient({
        method: "DELETE",
        url
    });

    return data;

};

